import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';

import Paginate from 'Components/Utility/Paginate';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import OrdersItemCard from 'Components/Order/OrdersItemCard';
import 'Components/Order/Orders.scss';

const messages = defineMessages({
  title: {
    id: 'orders.title',
    defaultMessage: 'Orders',
  },
});

const Orders = ({
  ordersPerPage,
  orders,
  searchTerm,
  searchResults,
}) => {
  const { formatMessage } = useIntl();
  const [currentPage, setCurrentPage] = useState(0);

  const { search } = location;

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const updateHits = (page) => {
    if (currentPage !== page) setCurrentPage(page);
  };


  if (!orders || orders.length === 0 || !currentPage) {
    return (
      <div className="text-center">
        <h3 className="pt-3">
          <FormattedMessage id="orders.empty-title" defaultMessage="You currently have no orders" />
        </h3>
        <p>
          <FormattedMessage
            id="orders.empty-message"
            defaultMessage="Orders containing product keys will appear here once you have made a purchase with Fanatical."
          />
        </p>
      </div>
    );
  }

  const nbPages = Math.ceil(orders.length / ordersPerPage) || 1;

  const chunkedPerPage = ordersPerPage;

  let chunkedOrders = chunk(orders, chunkedPerPage)[currentPage - 1];

  if (!chunkedOrders || !chunkedOrders.length) return false;

  if (!isEmpty(searchResults)) chunkedOrders = chunk(searchResults, chunkedPerPage)[0];


  if (!isEmpty(searchTerm) && isEmpty(searchResults)) return false;

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <div className="orders-table">
        <div className="table-header d-none d-md-flex">
          <div className="date-col"><FormattedMessage id="orders.date" defaultMessage="Date" /></div>
          <div className="item-col"><FormattedMessage id="orders.items" defaultMessage="Items" /></div>
          <div className="status-col"><FormattedMessage id="orders.status" defaultMessage="Status" /></div>
          <div className="action-col"><FormattedMessage id="orders.action" defaultMessage="Action" /></div>
        </div>
        <div className="table-header d-md-none">
          <div className="date-col">
            <FormattedMessage id="orders.orderitems" defaultMessage="Orders" />
          </div>
        </div>
        <div className="table-items">
          {chunkedOrders.length >= 1 && currentPage &&
              chunkedOrders.map(({ _id: id, date, items, status, isGiftSender }) =>
                <OrdersItemCard
                  key={id}
                  id={id}
                  date={date}
                  items={items}
                  status={status}
                  isGiftSender={isGiftSender}
                  itemsToShow={10}
                />,
              )
            }
        </div>
      </div>

      {isEmpty(searchResults) &&
      <Paginate
        hits={{ nbPages, page: currentPage - 1 }}
        updateHits={updateHits}
        pageLimit={100}
      />
        }
    </React.Fragment>
  );
};

Orders.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  searchResults: PropTypes.arrayOf(PropTypes.object),
  searchTerm: PropTypes.string,
  ordersPerPage: PropTypes.number,
};

Orders.defaultProps = {
  orders: null,
  searchTerm: '',
  searchResults: [],
  ordersPerPage: 20,
};

export default Orders;
